<template>
  <div class="dij-options-menu__row">
    <span v-if="icon" class="dij-options-menu__icon-slot">
      <b-icon :icon="icon" custom-size="mdi-20px" />
    </span>
    <img
      v-else-if="imgSrc"
      class="dij-options-menu__icon-img"
      :src="imgSrc"
      alt=""
    />
    <span class="dij-options-menu__label">
      <slot>{{ label }}</slot>
    </span>
  </div>
</template>

<script>
export default {
  name: 'OptionsMenuRow',
  props: {
    icon: {
      type: String,
      default: '',
    },
    imgSrc: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
  },
};
</script>
